exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__button___3H6HP{background:#f1f0ea;padding:.5em 1em;border-radius:5px;font-weight:700;text-transform:uppercase;font-size:18px;letter-spacing:1px;display:table-cell;width:-webkit-max-content;width:-moz-max-content;width:max-content}.index-module__button___3H6HP svg{margin-left:.7em}", ""]);

// exports
exports.locals = {
	"button": "index-module__button___3H6HP"
};